import { shallowEqual, useSelector } from 'react-redux';
import { get } from 'lodash';

const useModalProps = () => useSelector((state) => get(state, 'modal.modalProps', {}), shallowEqual);

const useModalWrapperProps = () => useSelector((state) => get(state, 'modal', { modalProps: {} }), shallowEqual);

export { useModalProps, useModalWrapperProps };
